import { z } from "zod";

export const patchOrganizationSettingsSchema = z.object({
	partnerReportsEmail: z.email().transform((val) => val.toLowerCase()),
	// Past 45 minutes a buffer changes nothing: no threshold asks for more rest than that.
	automaticBreakBufferMinutes: z.number().int().min(0).max(45),
});

export type PatchOrganizationSettingsSchema = z.infer<typeof patchOrganizationSettingsSchema>;
